import React from 'react';
import InfoToggle from '../../../../../../ComponentsV1/InfoToggle';
import { ChevronDown } from 'lucide-react';
import { ChevronUp } from 'lucide-react';
import { ArrowLeft } from 'lucide-react';
import { ItemCard } from '../../../../../../ComponentsV1/ItemCard/ItemCard';

const SelectedItemsThumbnail = ({ items }) => {
  const COUNT = 2;
  const itemsCount = items.length;

  if (!itemsCount) return null;

  const extraCount = itemsCount - COUNT;

  return (
    <div
      className={`tw-relative tw-w-16 tw-h-16 ${
        itemsCount > 1 ? 'tw-ml-2' : ''
      } `}
    >
      {items.slice(0, COUNT).map((item, index) => {
        const isTop = index === 1 || itemsCount === 1;

        return (
          <span
            key={`${item?.title}_${index}`}
            className={`tw-absolute tw-rounded-xl tw-bg-white tw-w-16 tw-h-16 tw-overflow-hidden tw-border tw-border-grey-200 tw-transition-all
                ${
                  index === 0 && itemsCount > 1
                    ? 'tw-rotate-[-13deg] tw-top-0 -tw-left-2'
                    : 'tw-top-0 tw-left-0'
                }
                ${index === 1 ? 'tw-top-0 tw-left-2' : ''}
                tw-border-solid tw-border-[1px] tw-rounded-[8px] tw-border-grey-200
              `}
          >
            <img
              src={item?.image || item?.media_url}
              alt='item'
              className='tw-w-full tw-h-full tw-object-cover'
            />

            {isTop && extraCount > 0 ? (
              <div className='tw-absolute tw-right-1 tw-bottom-1'>
                <div className='tw-rounded-full tw-bg-green-700 tw-min-w-[22px] tw-h-[22px] tw-flex tw-items-center tw-justify-center tw-text-white tw-text-[12px] tw-font-semibold tw-p-1'>
                  {`+${extraCount}`}
                </div>
              </div>
            ) : null}
          </span>
        );
      })}
    </div>
  );
};

const SelectedItemsUI = ({
  item_thumbnails,
  reso_assist_summary,
  editItemSelection,
}) => {
  return (
    <div className='tw-mb-6 tw-flex tw-flex-col'>
      {item_thumbnails?.length > 0 ? (
        <InfoToggle
          borderStyles='tw-border !tw-rounded-tl-[8px] !tw-rounded-tr-[8px] !tw-rounded-bl-[0px] !tw-rounded-br-[0px] tw-border-solid tw-border-grey-200'
          openIcon={
            <ChevronDown
              size={20}
              className='tw-mt-[1px] tw-text-grey-800 tw-mr-4'
            />
          }
          closeIcon={
            <ChevronUp
              size={20}
              className='tw-mt-[1px] tw-text-grey-800 tw-mr-4'
            />
          }
          isOpen={item_thumbnails?.length > 1}
          title={
            <div className='tw-flex tw-p-3 tw-px-4 tw-bg-white tw-rounded-[8px] tw-shadow-none tw-items-center tw-gap-4 tw-w-[80%]'>
              <SelectedItemsThumbnail items={item_thumbnails} />
              <div className='tw-flex tw-flex-col tw-gap-1'>
                <span className='tw-text-[1.5rem] tw-text-zinc-600 tw-font-medium tw-leading-none'>
                  {item_thumbnails?.length}{' '}
                  {item_thumbnails?.length === 1 ? 'item' : 'items'} selected
                </span>
                <span
                  className='tw-cursor-pointer tw-text-base-green tw-font-medium tw-text-[1.2rem] tw-flex tw-items-center tw-gap-1 tw-leading-none tw-w-fit'
                  onClick={() => {
                    editItemSelection();
                  }}
                  data-dd-action-name='Reso Assist Edit Items'
                >
                  <ArrowLeft size={14} strokeWidth={2.2} /> Edit
                </span>
              </div>
            </div>
          }
        >
          <div className='tw-flex tw-flex-col tw-w-full'>
            {item_thumbnails?.length > 0 &&
              item_thumbnails?.map((item, index) => (
                <ItemCard key={`${item?.title}_${index}`} itemDetails={item} />
              ))}
          </div>
        </InfoToggle>
      ) : null}

      <div
        className='tw-border !tw-border-t-0 !tw-rounded-tl-[0px] !tw-rounded-tr-[0px] !tw-rounded-bl-[8px] !tw-rounded-br-[8px] tw-border-solid tw-border-grey-200 tw-font-medium tw-text-[1.3rem] tw-p-2 tw-px-3 tw-leading-tight'
        style={{
          color: reso_assist_summary?.text_color || '#52525b',
          backgroundColor: reso_assist_summary?.bg_color || '#ffffff',
        }}
      >
        {reso_assist_summary?.text}
      </div>
    </div>
  );
};

export default SelectedItemsUI;
